import { alpha } from '@mui/material'

import { theme } from 'styles/theme'

import { DisputeStatus } from './types'

export const DISPUTE_STATUS_LABEL: Record<DisputeStatus, string> = {
  chargeback: 'Chargeback confirmado',
  won: 'Contestação ganha',
  expired: 'Prazo expirado',
  awaiting_documents: 'Aguardando envio',
  processing_pdf: 'Gerando defesa',
  ready_to_submit: 'Defesa enviada',
  defense_failed: 'Falha no envio da defesa'
}

export const DISPUTE_STATUS_LABEL_SHORT: Record<DisputeStatus, string> = {
  chargeback: 'Chargeback',
  won: 'Ganha',
  expired: 'Expirada',
  awaiting_documents: 'Aguardando envio',
  processing_pdf: 'Gerando defesa',
  ready_to_submit: 'Defesa enviada',
  defense_failed: 'Falha no envio'
}

export const DISPUTE_STATUS_COLOR: Record<DisputeStatus, string> = {
  chargeback: theme.palette.error[300],
  won: theme.palette.success[300],
  expired: theme.palette.neutral[400],
  awaiting_documents: theme.palette.alert[300],
  processing_pdf: theme.palette.info[300],
  ready_to_submit: theme.palette.info[300],
  defense_failed: theme.palette.error[300]
}

export const getDisputeChipSx = (status: DisputeStatus) => {
  // Status que esta versão não conhece (api publicada antes do conta) cai no neutro:
  // alpha(undefined) derruba a aba inteira.
  const color = DISPUTE_STATUS_COLOR[status] ?? theme.palette.neutral[400]
  return {
    background: alpha(color, 0.15),
    color,
    height: '25px',
    minWidth: '160px',
    fontSize: '14px',
    width: 'auto',
    maxWidth: '100%',
    fontWeight: 600,
    '& .MuiChip-label': {
      paddingLeft: '12px',
      paddingRight: '12px',
      overflow: 'visible',
      textOverflow: 'clip',
      whiteSpace: 'nowrap'
    }
  }
}
